import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { toast } from "wc-toast";
import { useLocation, useParams, Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { compact, isEmpty, startCase } from "lodash";
import AuthContext from "../context/AuthContext";
import helpers from "../utils/helpers";
import moment from "moment";
import { Helmet } from "react-helmet";
// import DetailSlip from "../components/DetailSlip";
import constants, { toFixedWithoutRounding } from "../utils/constants";
import { FaArrowDownWideShort, FaArrowUpWideShort } from "react-icons/fa6";

const MonthlyLossReport = () => {
  const parmas = useParams();
  const location = useLocation();
  const user_params = compact(location.pathname.split("/"));
  let { user } = useContext(AuthContext);
  let check = user_params[0];
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  const [getProperty, setProperty] = useState("none");
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [detailsData, setDetailsData] = useState([]);

  const [filter, setFilter] = useState({
    page: 1,
    keyword: "",
    page_size: 10,
    fromPeriod: previousDate,
    toPeriod: currentDate,
    filterByDay: "",
    created_by: parmas.id ? parmas.id : user?._id,
    userType: parmas.user_type ? parmas.user_type : user?.userType,
    limit: 100,
    sortBy: "",
    orderBy: "asc",
  });

  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
  };


  useEffect(() => {
    setFilter((prevState) => {
      return {
        ...prevState,
        created_by: parmas?.id,
        userType: parmas?.user_type,
      };
    });
  }, [parmas?.id]);
  const [obj, setObj] = useState({});
  const [data, setData] = useState([]);
  const [sumData, setSumData] = useState({});
  const sortData = (data, sortBy, orderBy) => {
    return [...data].sort((a, b) => {
      let valueA;
      let valueB;

      // Object fields
      if (
        ["admin", "super_admin", "sub_admin", "senior_super", "super_agent", "agent"].includes(
          sortBy
        )
      ) {
        valueA = a?.[sortBy]?.username || "";
        valueB = b?.[sortBy]?.username || "";
      } else {
        valueA = a?.[sortBy];
        valueB = b?.[sortBy];
      }

      // Number sorting
      if (typeof valueA === "number" && typeof valueB === "number") {
        return orderBy === "asc"
          ? valueA - valueB
          : valueB - valueA;
      }

      // String sorting
      return orderBy === "asc"
        ? String(valueA ?? "").localeCompare(String(valueB ?? ""))
        : String(valueB ?? "").localeCompare(String(valueA ?? ""));
    });
  };
  const [totalLoss, setTotalLoss] = useState(0);
  const getData = async (type = "search") => {
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let path = apiPath.monthlyLossReport;

    try {
      const { status, data: response_users } = await apiGet(
        path,
        type == "search" ? filter : type
      );
      if (status === 200) {
        if (response_users.success) {

          const resultData = response_users?.results?.data || [];
          const totalLoss = resultData.reduce((sum, item) => {
            return sum + (Number(item?.montlyLoss) || 0) * 0.02;
          }, 0);

          setTotalLoss(totalLoss);

          setData(
            sortData(
              resultData,
              filter.sortBy,
              filter.orderBy
            )
          );

          setPageCount(response_users.results.totalPages);

        }
      }
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  useEffect(() => {
    getData();
    setViewPage(filter.page ? filter.page - 1 : 0);
  }, [filter.sortBy, filter.orderBy]);

  const search = async (item) => {
    let obj = {
      keyword: filter.keyword,
      page: filter.page,
      page_size: filter.page_size,
      fromPeriod: filter.fromPeriod,
      toPeriod: filter.toPeriod,
      filterByDay: filter.filterByDay,
      created_by: item._id,
      userType: item?.userType,
    };
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let path = apiPath.monthlyLossReport;

    try {
      const { status, data: response_users } = await apiGet(path, obj);
      if (status === 200) {
        if (response_users.success) {
          setData(response_users.results.data);
          setPageCount(response_users.results.totalPages);
        }
      }
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };


  const handleSort = (key) => {
    setFilter((prev) => {
      if (prev.sortBy === key) {
        return {
          ...prev,
          orderBy: prev.orderBy === "asc" ? "desc" : "asc",
          page: 1,
        };
      }

      return {
        ...prev,
        sortBy: key,
        orderBy: "asc",
        page: 1,
      };
    });
  };
  const renderSortIcon = (key) => {
    if (filter.sortBy !== key) {
      return (
        <FaArrowDownWideShort
          style={{
            cursor: "pointer",
            marginLeft: 4,
            opacity: 0.4,
          }}
          color="white"
        />
      );
    }

    return filter.orderBy === "asc" ? (
      <FaArrowUpWideShort
        style={{ cursor: "pointer", marginLeft: 4 }}
        color="white"
      />
    ) : (
      <FaArrowDownWideShort
        style={{ cursor: "pointer", marginLeft: 4 }}
        color="white"
      />
    );
  };

  return (
    <div>
      {/* <Helmet>
        <meta name="viewport" content="width=device-width,  initial-scale=.2" />
      </Helmet> */}
      <section className="main-inner-outer py-4">
        <Container fluid>
        
          <Row>
            <div className="db-sec">
              <h2 className="common-heading">
                Monthly Loss Report
              </h2>
            </div>

            <Col md={12}>
              <div className="inner-wrapper">
                <Form className="bet_status">

                  <Row>

                    <Col xl={12} md={12}>
                      <Row>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-3 flex-grow-0 pe-3 "
                        >
                          <div className="bet-sec bet-period">
                            <Form.Label className="px-2">username</Form.Label>
                            <Form.Group className="form-group">
                              <Form.Control
                                className="small_form_control"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    keyword: e.target.value,

                                  })
                                }

                                type="text"
                              />

                            </Form.Group>
                          </div>
                        </Col>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-3 flex-grow-0 pe-3 "
                        >
                          <div className="bet-sec bet-period">
                            <Form.Label className="px-2">From</Form.Label>
                            <Form.Group className="form-group">
                              <Form.Control
                                className="small_form_control"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    fromPeriod: e.target.value,
                                    filterByDay: "",
                                  })
                                }
                                max={new Date().toISOString().split("T")[0]}
                                value={filter.fromPeriod}
                                type="date"
                              />
                              <Form.Control
                                className="small_form_control"
                                type="text"
                                placeholder="00:00"
                                disabled
                              />
                            </Form.Group>
                          </div>
                        </Col>
                        <Col
                          lg={3}
                          sm={6}
                          className="mb-lg-0 mb-3 flex-grow-0 ps-3"
                        >
                          <div className="bet-sec bet-period">
                            <Form.Label className="px-2">To</Form.Label>
                            <Form.Group className="form-group">
                              <Form.Control
                                className="small_form_control"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    toPeriod: e.target.value,
                                    filterByDay: "",
                                  })
                                }
                                min={
                                  filter?.fromPeriod
                                    ? new Date(filter?.fromPeriod)
                                      .toISOString()
                                      .split("T")[0]
                                    : new Date()
                                }
                                max={new Date().toISOString().split("T")[0]}
                                value={filter.toPeriod}
                                type="date"
                              />
                              <Form.Control
                                className="small_form_control"
                                type="text"
                                placeholder="23:59"
                                disabled
                              />
                            </Form.Group>
                          </div>
                        </Col>

                      </Row>
                    </Col>
                  </Row>
                  <div className="history-btn mt-2">
                    <ul className="list-unstyled mb-0">
                      <li>
                        <Button
                          className={
                            filter.filterByDay === "today"
                              ? "me-0 theme_dark_btn"
                              : "me-0 theme_light_btn"
                          }
                          onClick={(e) =>
                            setFilter({
                              ...filter,
                              filterByDay: "today",
                            })
                          }
                        >
                          Just For Today
                        </Button>
                      </li>
                      <li>
                        <Button
                          className={
                            filter.filterByDay === "yesterday"
                              ? "me-0 theme_dark_btn"
                              : "me-0 theme_light_btn"
                          }
                          onClick={(e) =>
                            setFilter({
                              ...filter,
                              filterByDay: "yesterday",
                            })
                          }
                        >
                          From Yesterday
                        </Button>
                      </li>
                      <li>
                        <Button
                          className="theme_dark_btn"
                          onClick={() => getData("search")}
                        >
                          Search
                        </Button>
                      </li>
                      <li>
                        <Button
                          className="me-0 theme_light_btn"
                          onClick={() => {
                            setFilter({
                              page: 1,
                              keyword: "",
                              page_size: 10,
                              fromPeriod: previousDate,
                              toPeriod: currentDate,
                              filterByDay: "",
                              created_by: parmas.id ? parmas.id : user?._id,
                              userType: parmas.user_type
                                ? parmas.user_type
                                : user?.userType,
                              sortBy: "",
                              orderBy: "asc",
                            });
                            getData({
                              page: 1,
                              keyword: "",
                              page_size: 10,
                              fromPeriod: previousDate,
                              toPeriod: currentDate,
                              filterByDay: "",
                              created_by: parmas.id ? parmas.id : user?._id,
                              userType: parmas.user_type
                                ? parmas.user_type
                                : user?.userType,
                              sortBy: "",
                              orderBy: "asc",
                            });
                          }}
                        >
                          Reset
                        </Button>
                      </li>
                    </ul>
                  </div>
                </Form>
              </div>
            </Col>
<section class="total-balance-sec">
    <div class="px-0 container-fluid">
        <ul class="list-unstyled">
            <li><dt>Total Loss Bonus</dt><strong> <span>{totalLoss.toFixed(2)}</span></strong></li>
            
        </ul>
    </div>
</section>
            <Col md={12} sm={12} lg={12} className="mt-2">
              <section className="account-table aprofit-downline aprofit-market w-100">
                <div className="responsive transaction-history table-color">
                  <Table>
                    <thead>
                      <tr>
                        <th scope="col" onClick={() => handleSort("admin")} style={{ cursor: "pointer" }}>AD ID {renderSortIcon("admin")}</th>
                        <th scope="col" onClick={() => handleSort("super_admin")} style={{ cursor: "pointer" }}>SSA ID {renderSortIcon("super_admin")}</th>
                        <th scope="col" onClick={() => handleSort("sub_admin")} style={{ cursor: "pointer" }}>SA ID {renderSortIcon("sub_admin")}</th>
                        <th scope="col" onClick={() => handleSort("senior_super")} style={{ cursor: "pointer" }}>SUP ID {renderSortIcon("senior_super")}</th>
                        <th scope="col" onClick={() => handleSort("super_agent")} style={{ cursor: "pointer" }}>MA ID {renderSortIcon("super_agent")}</th>
                        <th scope="col" onClick={() => handleSort("agent")} style={{ cursor: "pointer" }}>MA ID {renderSortIcon("agent")}</th>
                        <th scope="col" onClick={() => handleSort("username")} style={{ cursor: "pointer" }}>Username {renderSortIcon("username")}</th>
                         <th scope="col" onClick={() => handleSort("montlyLoss")} style={{ cursor: "pointer" }}>Last Month Loss Bonus {renderSortIcon("montlyLoss")}</th>
                        <th scope="col" onClick={() => handleSort("montlyLoss")} style={{ cursor: "pointer" }}>All Time Loss Bonus {renderSortIcon("montlyLoss")}</th>

                        {/* <th scope="col">Date</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {data && data?.length > 0 ? (
                          data?.map((item, index) => {

                            return (
                              <>

                                <>
                                  <tr key={index + 1}>
                                    <td>
                                      {item?.userType === "admin"
                                        ? item?.username
                                        : item?.admin?.username
                                          ? item?.admin?.username
                                          : "-"}
                                    </td>
                                    <td>
                                      {item?.userType === "super_admin"
                                        ? item?.username
                                        : item?.super_admin?.username
                                          ? item?.super_admin?.username
                                          : "-"}
                                    </td>
                                    <td>
                                      {item?.userType === "sub_admin"
                                        ? item?.username
                                        : item?.sub_admin?.username
                                          ? item?.sub_admin?.username
                                          : "-"}
                                    </td>
                                    <td>
                                      {item?.userType === "senior_super"
                                        ? item?.username
                                        : item?.senior_super?.username
                                          ? item?.senior_super?.username
                                          : "-"}
                                    </td>

                                    <td>
                                      {item?.userType === "super_agent"
                                        ? item?.username
                                        : item?.super_agent?.username
                                          ? item?.super_agent?.username
                                          : "-"}
                                    </td>
                                    <td>
                                      {item?.userType === "agent"
                                        ? item?.username
                                        : item?.agent?.username
                                          ? item?.agent?.username
                                          : "-"}
                                    </td>
                                    <td>
                                      <>
                                        {/* <Link
                                          to='#'
                                          onClick={() => search(item)}> */}
                                        {item?.username}
                                        {/* </Link> */}
                                      </>
                                    </td>

                                    <td>{toFixedWithoutRounding((item?.montlyLoss * 0.02))}</td>
                                    <td>{toFixedWithoutRounding((item?.montlyLossAll * 0.02))}</td>
                                    {/* <td>
                                      {helpers.dateFormat(
                                        item?.createdAt,
                                        user?.timeZone
                                      )}
                                    </td> */}

                                  </tr>


                                </>

                              </>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={12}>
                              <span>You have no bets in this time period.</span>
                            </td>
                          </tr>
                        )}
                        {data && data?.length > 0 && (
                          <>
                            <tr>
                              <th scope="col">Total</th>
                              <th scope="col">0</th>
                              <th>
                                {" "}
                                {obj?.downlinePnl ? (
                                  Math.sign(obj?.downlinePnl) !== -1 ? (
                                    <span className="text-danger">
                                      (
                                      {helpers.currencyFormat(
                                        "-" + obj?.downlinePnl
                                      )}
                                      )
                                    </span>
                                  ) : (
                                    <span className="text-success">
                                      {helpers.currencyFormat(
                                        Math.abs(obj?.downlinePnl)
                                      )}
                                    </span>
                                  )
                                ) : (
                                  "-"
                                )}
                              </th>
                              <th>
                                {obj?.downlinePnl ? (
                                  Math.sign(obj?.downlinePnl) === -1 ? (
                                    <span className="text-danger">
                                      (
                                      {helpers.currencyFormat(obj?.downlinePnl)}
                                      )
                                    </span>
                                  ) : (
                                    <span className="text-success">
                                      {helpers.currencyFormat(
                                        Math.abs(obj?.downlinePnl)
                                      )}
                                    </span>
                                  )
                                ) : (
                                  "-"
                                )}
                              </th>
                              <th>{helpers.currencyFormat(obj?.commission)}</th>
                              <th>
                                {obj?.downlinePnl ? (
                                  Math.sign(obj?.downlinePnl) !== -1 ? (
                                    <span className="text-danger">
                                      (
                                      {helpers.currencyFormat(
                                        "-" + obj?.downlinePnl
                                      )}
                                      )
                                    </span>
                                  ) : (
                                    <span className="text-success">
                                      {helpers.currencyFormat(
                                        Math.abs(obj?.downlinePnl)
                                      )}
                                    </span>
                                  )
                                ) : (
                                  "-"
                                )}
                              </th>
                              <th></th>
                              <th></th>
                            </tr>
                          </>
                        )}
                      </>
                    </tbody>
                  </Table>
                  <div className="bottom-pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      forcePage={viewpage}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={10}
                      pageCount={pageCount}
                      previousLabel="Prev"
                      renderOnZeroPageCount={null}
                      activeClassName="p-0"
                      activeLinkClassName="pagintion-li"
                    />
                  </div>
                </div>
              </section>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default MonthlyLossReport;